import { Button } from '../../Button/Button';
import type { ButtonProps, ButtonComponentType } from '../../Button/Button';

export type ChapterProps<T extends ButtonComponentType = 'button'> = Omit<
  ButtonProps<T>,
  'variant'
>;

export const Chapter = <T extends ButtonComponentType = 'button'>(
  props: ChapterProps<T>
) => {
  // @ts-expect-error react types...
  return <Button variant="contained" {...props} />;
};
